
const clientProviderFullcont        = require('./clientProvider-fullcont')

export function start(detail){  //console.log('company-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/


const obj = {
      fullcont:           { start: (detail)=>{  clientProviderFullcont. start(detail)        }},
}







